<div class="loading-overlay" *ngIf="isVisible">
    <div class="loading-content">
      <div class="spinner"></div>
      <p>Cargando...</p>
    </div>
  </div>